/**
 * Create Document Requirement Page
 */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminPageLayout, Section, Card } from '../../components';
import DocumentRequirementConfigurator from '../../components/admin/DocumentRequirementConfigurator';
import apiService from '../../services/api';

const CreateDocumentRequirement = () => {
  const navigate = useNavigate();
  const [clubData, setClubData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClubData();
  }, []);

  const loadClubData = async () => {
    try {
      setLoading(true);
      const userInfo = await apiService.getCurrentUser();
      const club_id = userInfo.club_id;

      if (club_id) {
        const clubResponse = await apiService.get('/api/clubs/public/club-info');
        setClubData({
          id: club_id,
          name: clubResponse.name || clubResponse.display_name || 'Club Name',
          club_id: club_id
        });
      }
    } catch (err) {
      console.error('Error loading club data:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    navigate('/admin/documents/requirements');
  };

  const handleCancel = () => {
    navigate('/admin/documents/requirements');
  };

  if (loading) {
    return (
      <AdminPageLayout
        title="CREATE DOCUMENT REQUIREMENT"
        subtitle="Configure automatic document assignment rules"
        backPath="/admin/documents/requirements"
        backLabel="← Back to Requirements"
        maxWidth="1400px"
      >
        <div style={{ padding: '4rem', textAlign: 'center', opacity: 0.6 }}>
          Loading...
        </div>
      </AdminPageLayout>
    );
  }

  return (
    <AdminPageLayout
      title="CREATE DOCUMENT REQUIREMENT"
      subtitle="Configure automatic document assignment rules"
      backPath="/admin/documents/requirements"
      backLabel="← Back to Requirements"
      maxWidth="1400px"
    >
      <Section title="REQUIREMENT CONFIGURATION">
        <Card level={1}>
          {clubData && (
            <DocumentRequirementConfigurator
              club_id={clubData.id}
              requirement={null}
              onSave={handleSave}
              onCancel={handleCancel}
            />
          )}
        </Card>
      </Section>
    </AdminPageLayout>
  );
};

export default CreateDocumentRequirement;
